module.exports = __webpack_public_path__ + "static/media/ic_audio_off_disable.c6052e05.svg";